import {
  IconAlignJustified,
  IconHash,
  IconList,
  IconSquareCheck,
  IconSelect,
} from "@tabler/icons-react";
import React from "react";

export const ICONS_ENUM: Record<string, React.ElementType> = {
  text: IconAlignJustified,
  number: IconHash,
  multiselect: IconList,
  select: IconSelect,
  boolean: IconSquareCheck,
};

type IconName = keyof typeof ICONS_ENUM;

interface DynamicIconProps {
  name: IconName;
  size?: number;
}
const PropertyIcon: React.FC<DynamicIconProps> = ({ name, size = 16 }) => {
  const IconComponent = ICONS_ENUM[name];
  if (!IconComponent) return null;
  return <IconComponent size={size} style={{ minWidth: size }} />;
};

export default PropertyIcon;
